import { render, staticRenderFns } from "./OaChatPackageInfo.vue?vue&type=template&id=24dd157b&scoped=true&"
import script from "./OaChatPackageInfo.vue?vue&type=script&lang=js&"
export * from "./OaChatPackageInfo.vue?vue&type=script&lang=js&"
import style0 from "./OaChatPackageInfo.vue?vue&type=style&index=0&id=24dd157b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd157b",
  null
  
)

export default component.exports